import { useTranslation } from 'react-i18next'

import { Chip } from '@mui/material'
import { useTheme } from '@mui/material/styles'

const LotTag = () => {
  const { t } = useTranslation('cost')
  const theme = useTheme()

  return (
    <Chip
      label={t('group.item.lot')}
      size="small"
      sx={{
        height: 18,
        fontSize: 11,
        borderRadius: 0.5,
        bgcolor: theme.palette.grey[200],
        color: theme.palette.text.secondary,
        '& .MuiChip-label': { px: 0.75 },
      }}
    />
  )
}

export default LotTag
